// extracted by mini-css-extract-plugin
export default {"container":"Quotes_container__CFZ9R","quote":"Quotes_quote__tlL-C","image":"Quotes_image__yrpca","text":"Quotes_text__gO3VJ","info":"Quotes_info__aaL1B"};